const INITIAL_STATE = {
  data: {},
  errors: {},
}
    
const pricingCalc = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_PRICING_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_PRICING_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default pricingCalc;